import eachEmployeeResponsibilityS1 from "@/assets/png/EachEmployeeResponsibility/eachEmployeeResponsibilityS1.png";
import eachEmployeeResponsibilityS2 from "@/assets/png/EachEmployeeResponsibility/eachEmployeeResponsibilityS2.png";
import eachEmployeeResponsibilityS3 from "@/assets/png/EachEmployeeResponsibility/eachEmployeeResponsibilityS3.png";
import eachEmployeeResponsibilityS4 from "@/assets/png/EachEmployeeResponsibility/eachEmployeeResponsibilityS4.png";
import eachEmployeeResponsibilityS5 from "@/assets/png/EachEmployeeResponsibility/eachEmployeeResponsibilityS5.png";
import eachEmployeeResponsibilityS6 from "@/assets/png/EachEmployeeResponsibility/eachEmployeeResponsibilityS6.png";

import { Answer, IQuizList, ISlides } from "@/pages/SecurityAwareness/types";

export const eachEmployeeResponsibilityQuiz: Array<IQuizList> = [
  {
    name: "step1",
    question: "1. What is a potential risk caused by employee actions?",
    options: [
      { value: "1", label: "Using VPNs and strong passwords" },
      { value: "2", label: "Installing OS updates" },
      {
        value: Answer.Correct,
        label: "Connecting to unsafe Wi-Fi without protection",
      },
      { value: "4", label: "Locking your screen when away" },
    ],
  },
  {
    name: "step2",
    question: "2. What should you do if your work device is lost or stolen?",
    options: [
      { value: "1", label: "Try to find it on your own" },
      {
        value: Answer.Correct,
        label: "Immediately report it and use remote wipe if possible",
      },
      { value: "3", label: "Wait and see if it turns up" },
      { value: "4", label: "Ignore if it’s just a phone" },
    ],
  },
  {
    name: "step3",
    question: "3. Which behavior is recommended when working remotely?",
    options: [
      { value: "1", label: "Accessing work files on public devices" },
      {
        value: Answer.Correct,
        label:
          "Use a VPN on public/home networks and lock your screen whenever you step away",
      },
      { value: "3", label: "Sharing your device with family" },
      { value: "4", label: "Disabling auto-lock for convenience" },
    ],
  },
  {
    name: "step4",
    question: "4. When should you report a suspicious email or behavior?",
    options: [
      {
        value: Answer.Correct,
        label: "Immediately, even if you’re unsure",
      },
      { value: "2", label: "Only if a file is actually opened" },
      { value: "3", label: "After asking a coworker first" },
      { value: "4", label: "Never, unless IT contacts you" },
    ],
  },
  {
    name: "step5",
    question: "5. Why is following security policies important?",
    options: [
      { value: "1", label: "To avoid working overtime" },
      {
        value: Answer.Correct,
        label: "To protect company data and prevent breaches",
      },
      { value: "3", label: "So IT doesn’t monitor your activity" },
      { value: "4", label: "They are optional suggestions" },
    ],
  },
];

export const eachEmployeeResponsibilitySlides: Array<ISlides> = [
  { id: 1, content: <img src={eachEmployeeResponsibilityS1} alt="slide1" /> },
  { id: 2, content: <img src={eachEmployeeResponsibilityS2} alt="slide2" /> },
  { id: 3, content: <img src={eachEmployeeResponsibilityS3} alt="slide3" /> },
  { id: 4, content: <img src={eachEmployeeResponsibilityS4} alt="slide4" /> },
  { id: 5, content: <img src={eachEmployeeResponsibilityS5} alt="slide5" /> },
  { id: 6, content: <img src={eachEmployeeResponsibilityS6} alt="slide6" /> },
];
